export default __webpack_public_path__ + "static/media/EditInventory.dd674834.svg";